// extracted by mini-css-extract-plugin
module.exports = {"root":"SiteMostReviewedShopCard_root__Zej5k","avatar":"SiteMostReviewedShopCard_avatar__bLgVK"};